import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=d42bef50&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"
import style0 from "./profile.vue?vue&type=style&index=0&id=d42bef50&prod&lang=scss"
import style1 from "./profile.vue?vue&type=style&index=1&id=d42bef50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42bef50",
  null
  
)

export default component.exports